import { defineMessages } from 'react-intl';

type PromptCardMessage = {
	id: string;
	defaultMessage: string;
	description: string;
};

// Explicit type because `isolatedDeclarations` cannot infer an exported const built from a call.
export const thirdPartyPromptCardMessages: {
	connectCta: PromptCardMessage;
	connectSuccessTitle: PromptCardMessage;
	connectSuccessDescription: PromptCardMessage;
	connectSuccessConnectMoreApps: PromptCardMessage;
	connectErrorTitle: PromptCardMessage;
	connectErrorDescription: PromptCardMessage;
	connectErrorTryAgain: PromptCardMessage;
} = defineMessages({
	connectCta: {
		id: 'experiment-related-content-connections.prompt-card.connect-cta',
		defaultMessage: 'Supercharge your recommendations and search results by connecting {appName}',
		description:
			'Call to action on a card at the end of a page, inviting the reader to connect a third-party product such as Google Drive so its content appears in related content and search. {appName} is the product name.',
	},
	connectSuccessTitle: {
		id: 'experiment-related-content-connections.prompt-card.connect-success.title',
		defaultMessage: 'Connected to {appName}',
		description:
			'Title of the flag confirming the reader connected a third-party product. {appName} is the product name.',
	},
	connectSuccessDescription: {
		id: 'experiment-related-content-connections.prompt-card.connect-success.description',
		defaultMessage: 'Now you can access your {appName} content without leaving Confluence',
		description:
			'Body of the success flag shown after connecting a third-party product, telling the reader they can open that product’s content in Confluence. {appName} is the product name.',
	},
	connectSuccessConnectMoreApps: {
		id: 'experiment-related-content-connections.prompt-card.connect-success.connect-more-apps',
		defaultMessage: 'Connect more apps',
		description:
			'Action on the success flag that opens the universal connector modal so the reader can connect additional apps.',
	},
	connectErrorTitle: {
		id: 'experiment-related-content-connections.prompt-card.connect-error.title',
		defaultMessage: 'Couldn’t connect to {appName}',
		description:
			'Title of the flag shown when connecting a third-party product fails. {appName} is the product name.',
	},
	connectErrorDescription: {
		id: 'experiment-related-content-connections.prompt-card.connect-error.description',
		defaultMessage: 'We couldn’t connect to {appName}. Please try connecting your account again.',
		description:
			'Body of the flag shown when connecting a third-party product fails. {appName} is the product name.',
	},
	connectErrorTryAgain: {
		id: 'experiment-related-content-connections.prompt-card.connect-error.try-again',
		defaultMessage: 'Try again',
		description: 'Action on the error flag that retries connecting the third-party product.',
	},
});
